import { render, staticRenderFns } from "./Rreferanse.vue?vue&type=template&id=5a99935c&scoped=true&"
import script from "./Rreferanse.vue?vue&type=script&lang=js&"
export * from "./Rreferanse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a99935c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
installComponents(component, {
  VCarousel,
  VCarouselItem,
})
